import React, { useState, useContext, useEffect } from 'react'
import { Container, useMediaQuery, Tabs, Tab } from '@material-ui/core'
import './BrokerPortal.scss'
import FlexView from 'react-flexview/lib'
import { GetEmailPopup } from './Common/GetEmailPopup'
import { SessionContextStore } from '../../context/SessionContext'
import { useHistory, useLocation } from 'react-router-dom'
import {
    EventEmitterService,
    EventKey,
} from '../../services/EventEmitterService'
import { AccountsTable } from './Common/AccountsTable'
import { RecentSubmissionsTable } from './Common/RecentSubmissionsTable'
import UserProfileModel from '../../models/user-models/UserProfileModel'
import { USER_STATUS } from '../../models/user-models/UserStatus'
import { InsurerLogo } from '../Core/InsurerLogo'
import { InsuranceBillingPeriod } from '../../models/insurance-models/InsuranceBillingPeriodModel'

export const BrokerPortalTables = () => {
    const [popup, setPopup] = useState({
        open: false,
        title: '',
        body: '',
        action: '',
    })
    const sessionContext = useContext(SessionContextStore)
    const history = useHistory()
    const location = useLocation()
    const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))
    const initialTabIndex = location.pathname.endsWith('active') ? 1 : 0
    const [tabIndex, setTabIndex] = React.useState(initialTabIndex)

    useEffect(() => {
        setTabIndex(location.pathname.endsWith('active') ? 1 : 0)
    }, [location.pathname])

    const onConfirm = async (data: UserProfileModel) => {
        let res = await sessionContext.bindUserForBroker(data.email)
        if (res.ok) {
            if (data.action == 'monthlyBind') {
                history.push('/insurance')
            } else if (data.action == 'annualBind') {
                history.push('/insurance')
            } else {
                if (data.status == USER_STATUS.BOUND) {
                    history.push('/policy-management')
                    return
                }
                if (data.latestQuote) {
                    history.push(
                        '/insurance/annual?quote=' +
                            data.latestQuote.stateBase64
                    )
                } else if (data.latestState) {
                    history.push(
                        '/insurance/annual?quote=' +
                            data.latestState.stateBase64
                    )
                } else {
                    history.push('/insurance/annual')
                }
            }
        }
    }

    const onQuoteClick = async (quote) => {
        let res = await sessionContext.bindUserForBroker(quote.email)

        if (res.ok) {
            let quoteBase64Representation = undefined
            let billingPeriod = InsuranceBillingPeriod.YEAR
            if (quote.latestQuote) {
                quoteBase64Representation = quote.latestQuote.state_base64
                billingPeriod = quote.latestQuote.billing_period
            } else if (quote.latestState) {
                quoteBase64Representation = quote.latestState.state_base64
                billingPeriod = quote.latestState.billing_period
            }

            if (billingPeriod == InsuranceBillingPeriod.MONTH)
                history.push(
                    `/insurance/monthly${
                        quoteBase64Representation
                            ? '?quote=' + quoteBase64Representation
                            : ''
                    }`
                )
            else
                history.push(
                    `/insurance/annual${
                        quoteBase64Representation
                            ? '?quote=' + quoteBase64Representation
                            : ''
                    }`
                )
        }
    }

    const bindAnnual = () =>
        setPopup({
            open: true,
            title: 'Quote / Bind Coverage',
            body: "Insert the insured's email",
            action: 'annualBind',
        })
    const bindMonthly = () =>
        setPopup({
            open: true,
            title: 'Quote / Bind Coverage',
            body: "Insert the insured's email",
            action: 'monthlyBind',
        })
    const cancelPopup = () =>
        setPopup({ open: false, title: '', body: '', action: '' })
    const handleTabChange = (event, newValue) => setTabIndex(newValue)
    const openDashboard = () =>
        window.open(
            'http://partnerd.eastus.cloudapp.azure.com/pages/dashboard',
            '_blank'
        )
    const onUserClick = (user) => onConfirm(user)

    return (
        <Container maxWidth="lg" className="margin-top-basic">
            <FlexView hAlignContent={'center'} column={isMobile}>
                {isMobile && (
                    <div className="text-title textcenter black bolder margin-top-basic">
                        Broker Portal
                    </div>
                )}
                <Tabs
                    orientation={isMobile ? 'horizontal' : 'vertical'}
                    variant="scrollable"
                    value={tabIndex}
                    indicatorColor={'primary'}
                    textColor="primary"
                    onChange={handleTabChange}
                >
                    <Tab label="Recent Submissions" />
                    <Tab label="Active Accounts" />
                </Tabs>
                <div className="full-width margin-left-basic margin-right-basic">
                    {!isMobile && (
                        <FlexView className="space-between">
                            <div className="text-promotion black bolder margin-top-basic margin-bottom-basic">
                                Broker Portal
                            </div>
                            <InsurerLogo />
                        </FlexView>
                    )}

                    {tabIndex == 0 && (
                        <Container maxWidth="lg">
                            <RecentSubmissionsTable
                                newCustomerClick={bindAnnual}
                                onRowClick={onQuoteClick}
                            />
                        </Container>
                    )}

                    {tabIndex == 1 && (
                        <Container maxWidth="lg">
                            <AccountsTable
                                newCustomerClick={bindAnnual}
                                onRowClick={onUserClick}
                            />
                        </Container>
                    )}
                </div>
            </FlexView>

            <GetEmailPopup
                onCancel={cancelPopup}
                open={popup.open}
                title={popup.title}
                body={popup.body}
                onConfirm={onConfirm}
                duration={popup.action}
            />
        </Container>
    )
}
